export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/z3_worker.81f2067d.worker.js");
}
